import storageService from "@/services/middleware/storageService";
import { shutdownCrisp } from "@/components/crisp/use-crisp";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface AuthState {
  auth: {
    isAuthenticated: boolean;
    validUser: boolean;
  };
  accountLocked: boolean;
  setAccountLocked: (locked: boolean) => void;
  setSignup: () => void;
  setSignupPlanUserValidation: () => void;
  setLogin: (data: { hash: string }) => void;
  setResetPassword: (data: { hash: string }) => void;
  setLogout: () => void;
}

export const useAuthStore = create<AuthState>()(
  devtools(
    (set) => ({
      auth: {
        isAuthenticated: Boolean(storageService.getItem("token")),
        validUser: false,
      },
      accountLocked: false,
      setAccountLocked: (locked) =>
        set((state) => ({ ...state, accountLocked: locked })),
      setSignup: () => {
        window.location.href = `/auth/login?verified=true`;
        set((state) => state);
      },
      setSignupPlanUserValidation: () => {
        return set(
          (state) => ({ auth: { ...state.auth, validUser: true } }),
        );
      },
      setLogin: (data) => {
        // clearing login-as-admin
        storageService.removeItem("is-ghost");
        storageService.removeItem("ghost-role");
        storageService.setItem("token", data.hash);
        window.location.href = "/role";
        set((state) => ({ ...state, accountLocked: false }));
      },
      setResetPassword: (data) => {
        storageService.setItem("token", data.hash);
        window.location.href = "/role";
        set((state) => state);
      },
      setLogout: () => {
        storageService.removeItem("token");
        storageService.removeItem("activeRelationshipId");
        storageService.removeItem("sensor");
        // Remove ghosts-specific items
        storageService.removeItem("is-ghost");
        storageService.removeItem("ghost-role");
        shutdownCrisp();
        return set(
          (state) => ({ ...state, accountLocked: false, auth: { isAuthenticated: false, validUser: false } }),
        );
      },
    }),
    {
      name: "AuthStore",
    }
  )
);
